import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { UsuariosService } from "app/usuarios/services/usuarios.service";
import { UsuariosCadastrarComponent } from "app/usuarios/usuarios-cadastrar/usuarios-cadastrar.component";
import { finalize, Subscription } from "rxjs";

@Component({
    selector: "app-usuarios-lista-tabela",
    templateUrl: "./usuarios-lista-tabela.component.html",
    styleUrls: ["./usuarios-lista-tabela.component.scss"],
})
export class UsuariosListaTabelaComponent extends BaseComponent implements OnInit {
    @ViewChild(UsuariosListaTabelaComponent, { static: false }) table!: UsuariosListaTabelaComponent;
    @Input() deleted: boolean = false;
    @Input() override params: any;
    override loadingIndicator: boolean = false;

    inputSubscription!: Subscription;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public service: UsuariosService
    ) {
        super(dialog, snackBar);
    }

    ngOnInit(): void {
        this.params.deleted = this.deleted;
        this.getAll();
    }

    applyFilters(result: any) {
        this.params.escritorio_id = result.escritorio_id;
        this.params.role_id = result.role_id;
        this.params.name = result.name;
        this.paginator.firstPage();
        this.getAll();
    }

    getAll() {
        this.loadingIndicator = true;
        this.inputSubscription = this.service
            .getAll(this.params)
            .pipe(finalize(() => (this.loadingIndicator = false)))
            .subscribe(
                (data) => {
                    this.length = data.meta.total;
                    this.rows = data.data;
                    this.temp = [...this.rows];
                },
                (error) => {
                    console.error(error);
                }
            );
    }

    pageEvent(event: PageEvent) {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;
        this.getAll();
    }

    onSelect(event: any) {
        if (event.type == "click") {
            const row = event.row;
            this.openAlterar(row.id);
        }
    }

    onSort(event: any) {
        this.params.sortColumn = event.column.prop;
        this.params.sortOrder = event.newValue;
        this.getAll();
    }

    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(UsuariosCadastrarComponent, {
            panelClass: "contact-form-dialog",
            width: "400px",
            data: { id: id },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Usuário alterado com sucesso!");
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar atualizar o cadastro do usuário.");
            }
        });
    }

    getNameEscritorio(escritorio: { nome_fantasia: string }[]) {
        if (!escritorio?.length) {
            return "";
        }
        return escritorio.map((e) => e.nome_fantasia).join(", ");
    }

    stopNow() {
        this.inputSubscription.unsubscribe();
    }
}
